/* eslint-disable */
import axios from "@/axios";
import store from "@/store";

export function getSupportedLanguages({ params, signal }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.get("/text_translate", { headers, params, signal });
}

export function detectLanguage({ params, payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.put("/text_translate", payload, { headers, params });
}

export function translateText({ payload }) {
  const headers = {
    "Content-Type": "application/json",
    "Authorization": `Bearer ${store.getters['user/currentToken']}`,
  };

  return axios.post("/text_translate", payload, { headers });
}
